import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

// Usage:
// <tbody
//   data-controller="sortable"
//   data-sortable-url-value="/admin/items/sort"
//   data-sortable-item-selector-value="tr[data-id]"
//   data-sortable-handle-value=".drag-handle"
// ></tbody>

export default class extends Controller {
    static values = {
        url: String,
        itemSelector: { type: String, default: "li" },
        handle: String
    }
    static outlets = ["toast"];

    connect() {
        this.sortable = Sortable.create(this.element, {
            handle: this.handleValue || undefined,
            draggable: this.itemSelectorValue,
            onEnd: this.onEnd.bind(this)
        });
    }

    disconnect() {
        this.sortable?.destroy();
    }

    async onEnd() {
        const ids = this.ids();
        await this.save(ids);
    }

    async updateSingleOrder(event) {
        const lotId = event.target.dataset.lotId;
        const newOrder = parseInt(event.target.value);
        
        if (newOrder < 1) {
            event.target.value = 1;
            return;
        }

        await this.reorderRecordsWithNewPosition(lotId, newOrder);
    }

    async reorderRecordsWithNewPosition(updatedLotId, newPosition) {
        const currentIds = this.ids();
        
        const otherIds = currentIds.filter(id => id !== updatedLotId);
        
        const insertIndex = Math.min(newPosition - 1, otherIds.length);
        otherIds.splice(insertIndex, 0, updatedLotId);
        
        await this.save(otherIds);
    }

    ids() {
        return Array.from(this.element.querySelectorAll(this.itemSelectorValue))
            .map(el => el.dataset.id);
    }

    async save(ids) {
        const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        
        try {
            const response = await fetch(this.urlValue, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-Token": token,
                    "Accept": "text/vnd.turbo-stream.html"
                },
                body: JSON.stringify({ order: ids })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            this.toastOutlet?.show('Positions have been updated!', "notice");

            const turboStream = await response.text();
            Turbo.renderStreamMessage(turboStream);
        } catch (error) {
            this.toastOutlet?.show('Failed to update position!', "error");
        }
    }
}